<!-- TODO -->
<!-- <link href="/../../assets/css/font.css" rel="stylesheet" *appShellNoRender> -->
<app-card-editor #cardEditor [projectConfig]="projectConfig"
    *ngIf="isDataLoaded"
     [currentCard]="currentCard"></app-card-editor>
<section [class]="rootClass" *ngIf="isDataLoaded">
    <!-- <div class="p-box container-fluid">
        <div class="i-container admin-card-box mt-2">
            <div class="form-row justify-content-between my-2 card-preview-btn align-items-center">
                <div class="col-md-auto col-auto mt-0 mt-md-2" (click)="goBack()">
                    <div class="d-flex align-items-center cursor-pointer">
                        <span class="material-icons ">
                            arrow_back
                        </span>
                        <span class="ml-2 text-black font-weight-bold">
                            Back
                        </span>
                    </div>
                </div>
                <div class="col-md-auto col ml-auto my-drp">
                    <div class="form-row align-items-center">
                        <div class="col-md-auto col-auto">
                            <button class="btn btn-outline-main cursor-pointer"
                                (click)="downloadCard(true)">Save</button>
                        </div>
                        <div class="col-md-auto col">
                            <div ngbDropdown class="d-inline-block">
                                <button type="button" class="btn btn-main" id="dropdownBasic1" ngbDropdownToggle>
                                    Download Options
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="downloadWithWaterMark(false)">Download (With
                                        Watermark)</button>
                                    <button ngbDropdownItem (click)="downloadCard(false)">Pay & Download
                                        (Without Watermark)</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div style="display: none;">
        <div class="avatar-edit">
            <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg"
                #fileInput onclick="this.value = null"
                (change)="uploadFile($event,shapeData)" />
        </div>
        <button #buttoninput class="btn btn-danger btn-lg btn-block"
            (click)="fileInput.click()">Upload Image</button>
    </div>
</section>